(function () {
  'use strict';

  /* ---- Slider ---- */
  function initSlider(section) {
    var track = section.querySelector('.bm-bestsellers__track');
    if (!track) return;

    var prevBtn = section.querySelector('.bm-bestsellers__arrow--prev');
    var nextBtn = section.querySelector('.bm-bestsellers__arrow--next');
    var cards   = track.querySelectorAll('.bm-bestsellers__card');
    var idx = 0;

    function visibleCount() {
      var w = window.innerWidth;
      if (w >= 1200) return 4;
      if (w >= 900)  return 3;
      if (w >= 600)  return 2;
      return 1;
    }

    function cardWidth() {
      return cards[0] ? cards[0].offsetWidth + 24 : 330;
    }

    function maxIdx() {
      return Math.max(0, cards.length - visibleCount());
    }

    function update() {
      track.style.transform = 'translateX(-' + (idx * cardWidth()) + 'px)';
      if (prevBtn) prevBtn.disabled = idx === 0;
      if (nextBtn) nextBtn.disabled = idx >= maxIdx();
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { if (idx > 0) { idx--; update(); } });
    if (nextBtn) nextBtn.addEventListener('click', function () { if (idx < maxIdx()) { idx++; update(); } });
    window.addEventListener('resize', function () { idx = Math.min(idx, maxIdx()); update(); });

    update();
  }

  /* ---- AJAX Add to Cart ---- */
  function initCart(section) {
    section.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-add-to-cart]');
      if (!btn) return;

      var variantId = btn.dataset.variantId;
      if (!variantId) return;

      btn.disabled = true;
      btn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.id) {
          btn.textContent = 'Added!';
          // Refresh cart count bubble if Dawn's cart API is available
          if (typeof window.Shopify !== 'undefined') {
            fetch('/cart.js')
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                var bubbles = document.querySelectorAll('.cart-count-bubble span[aria-hidden]');
                bubbles.forEach(function (el) { el.textContent = cart.item_count; });
                var countEls = document.querySelectorAll('[data-cart-count]');
                countEls.forEach(function (el) { el.textContent = cart.item_count; });
              });
          }
          setTimeout(function () {
            btn.disabled = false;
            btn.textContent = 'Add to Cart';
          }, 2000);
        } else {
          btn.disabled = false;
          btn.textContent = data.description || 'Error — try again';
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Error — try again';
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.bm-bestsellers').forEach(function (section) {
      initSlider(section);
      initCart(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.bm-bestsellers');
    if (section) { initSlider(section); initCart(section); }
  });
})();
